// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatWeDo_container__PVEhh","serviceRoot":"WhatWeDo_serviceRoot__VE_nF"};